import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { Row as Row$1 } from 'react-styled-flexboxgrid';

const propTypes = {
  /**
   * @ignore
   */
  children: PropTypes.node.isRequired
};
const RowWrapper = styled.div.withConfig({
  displayName: "RowWrapper",
  componentId: "VDS__sc-kr4awm-0"
})`
  width: 100%;
`;
const StyledRow = styled(Row$1).withConfig({
  displayName: "StyledRow",
  componentId: "VDS__sc-kr4awm-1"
})`
  max-width: 1272px;
`;
const Row = props => {
  return React.createElement(RowWrapper, {
    bleed: props.bleed,
    className: props.className
  }, React.createElement(StyledRow, Object.assign({}, props), props.children));
};
Row.propTypes = propTypes;

export { Row as default };
